import { Helmet } from 'react-helmet-async';

function AboutUsHelmetComponent() {
  return (
    <Helmet>
      {/* Sivun otsikko */}
      <title>Spiderlegs Productions | Meistä ja palveluistamme</title>
      
      {/* Meta-kuvaus */}
      <meta name="description" content="Spiderlegs Productions tarjoaa äänentoistoa ja esitystekniikkaa tapahtumiin Keravalla ja Uudellamaalla. Tutustu tarinaamme ja palveluihimme!" />
      
      {/* Meta-avainsanat */}
      <meta name="keywords" content="Spiderlegs Productions, meistä, äänentoistopalvelut, esitystekniikka, tapahtumat, Kerava, Uusimaa" />
      
      {/* Meta-kirjoittaja */}
      <meta name="author" content="Spiderlegs Productions" />
      
      {/* Canonical-linkki */}
      <link rel="canonical" href="https://spiderlegsproductions.com/meista" />
      
      {/* Open Graph -tunnisteet */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Spiderlegs Productions | Meistä ja palveluistamme" />
      <meta property="og:description" content="Spiderlegs Productions tarjoaa äänentoistoa ja esitystekniikkaa tapahtumiin Keravalla ja Uudellamaalla. Tutustu tarinaamme ja palveluihimme!" />
      <meta property="og:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
      <meta property="og:url" content="https://spiderlegsproductions.com/meista" />
      
      {/* Twitter Card -tunnisteet */}
      <meta name="twitter:title" content="Spiderlegs Productions | Meistä ja palveluistamme" />
      <meta name="twitter:description" content="Spiderlegs Productions tarjoaa äänentoistoa ja esitystekniikkaa tapahtumiin Keravalla ja Uudellamaalla. Tutustu tarinaamme ja palveluihimme!" />
      <meta name="twitter:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}

export default AboutUsHelmetComponent;
